<div class="container-fluid">
    <div class="row">

        <div class="card shadow-sm p-0">
            <div class="card-header">
                <h3 class="card-title">{{ companyId ? 'Update Company' : 'Company User' }} </h3>
            </div>
            <div class="card-body">
                <company-form [company]="company" />
            </div>
        </div>
    </div>

</div>